"use client";

import { Map, X } from "@/components/icons";
import { ProductTypeFilter } from "./primary-filters";
import { LocationFilter } from "./location-filter";
import { ConditionFilter, PriceFilter } from "./secondary-filters";
import { MoreFiltersChip } from "./more-filters";
import { useHeroMapContext } from "@/components/home/context/hero-map-context";
import { AdvancedFiltersToggle, AdvancedFiltersPanel } from "./advanced-filters";
import { IntentFilter } from "./intent-filter";
import { SearchInput } from "./search-input";
import { PhoneFilterBar } from "./phone-filter-bar";
import { useListingBrowseContext } from "../context/listing-browse-context";
import { Button } from "@/components/ui/button";

function ClearFiltersButton() {
  const { hasActiveFilters, clearAllFilters } = useListingBrowseContext();
  const heroMap = useHeroMapContext();
  const hasLocation = heroMap.location !== null;
  if (!hasActiveFilters && !hasLocation) return null;

  return (
    <Button
      type="button"
      variant="destructive-quiet"
      size="compact"
      onClick={() => {
        clearAllFilters();
        heroMap.setLocation(null);
      }}
      className="self-start rounded-sm hover:text-destructive-strong/80 lg:self-center"
    >
      <X className="h-3.5 w-3.5" />
      Clear all
    </Button>
  );
}

function MapToggleButton() {
  const { mapAvailable, mapVisible, toggleMap } = useListingBrowseContext();
  if (!mapAvailable) return null;

  return (
    <Button
      type="button"
      variant="outline"
      size="compact"
      onClick={toggleMap}
      aria-pressed={mapVisible}
      className="hidden shrink-0 rounded-sm lg:ml-auto lg:inline-flex"
    >
      <Map />
      {mapVisible ? "Hide map" : "Show map"}
    </Button>
  );
}

export function HorizontalFilterBar({
  onOpenMap,
  resultCount,
}: {
  onOpenMap: () => void;
  resultCount: number | null;
}) {
  return (
    <div className="flex-shrink-0 border-b border-border bg-background">
      <PhoneFilterBar onOpenMap={onOpenMap} resultCount={resultCount} />
      <div className="hidden flex-col gap-2 px-4 py-3 md:flex lg:flex-row lg:flex-wrap lg:items-start lg:gap-3">
        <SearchInput
          id="marketplace-filter-search"
          className="w-full lg:w-72 lg:shrink-0"
        />
        <ClearFiltersButton />
        <div className="flex min-w-0 flex-1 flex-wrap items-center gap-2 lg:order-last lg:basis-full">
          <ProductTypeFilter />
          <LocationFilter />
          <IntentFilter />
          <PriceFilter />
          <ConditionFilter />
          <AdvancedFiltersToggle />
          <MoreFiltersChip />
        </div>
        <MapToggleButton />
      </div>

      <AdvancedFiltersPanel />
    </div>
  );
}
